/**
 * Keep campaigns with delivery in the report date range (unified maximum metrics).
 * Missing unified nodes are not confirmed zero — tracked as incomplete.
 */

const hasPositiveMetric = (metrics) => {
  if (!metrics || typeof metrics !== "object") {
    return false;
  }

  return Number(metrics.impressions || 0) > 0 || Number(metrics.spend || 0) > 0;
};

export const campaignHasReportActivity = (unifiedCampaign) => {
  if (!unifiedCampaign) {
    return false;
  }

  const platforms = unifiedCampaign.platforms || [];

  return platforms.some((platform) => {
    const metrics =
      unifiedCampaign?.levels?.campaign?.maximum?.[platform]?.campaign;
    return hasPositiveMetric(metrics);
  });
};

/**
 * @param {Object} params
 * @param {Object} params.campaigns - Candidate campaigns keyed by id
 * @param {Object} params.statistics - Unified getUnifiedCampaignStatistics data
 * @returns {{ campaignsWithActivity: Object, incompleteCampaignIDs: string[] }}
 */
export const filterCampaignsByReportActivity = ({
  campaigns = {},
  statistics = {},
} = {}) => {
  const campaignsStats = statistics?.campaigns || {};
  const campaignsWithActivity = {};
  const incompleteCampaignIDs = [];

  Object.keys(campaigns || {}).forEach((campaignID) => {
    const unifiedCampaign = campaignsStats[campaignID];

    if (!unifiedCampaign) {
      incompleteCampaignIDs.push(campaignID);
      return;
    }

    if (campaignHasReportActivity(unifiedCampaign)) {
      campaignsWithActivity[campaignID] = campaigns[campaignID];
    }
  });

  return {
    campaignsWithActivity,
    incompleteCampaignIDs,
  };
};

export default filterCampaignsByReportActivity;
